export const TG_PROXY_LINK = 'https://telegram.me/proxy?server=black-hole.work&port=443&secret=332118ca9d8244b46f1fa7c001650042';